/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Users_ProInputs */



/**
* | output |
* | --- |
* | "1-25" |
*
* @param {Signup_Compare_Users_ProInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_users_pro = /** @type {((inputs?: Signup_Compare_Users_ProInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Users_ProInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("1-25")
	if (locale === "de") return /** @type {LocalizedString} */ ("1-25")
	if (locale === "it") return /** @type {LocalizedString} */ ("1-25")
	if (locale === "ru") return /** @type {LocalizedString} */ ("1-25")
	if (locale === "es") return /** @type {LocalizedString} */ ("1-25")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("1-25")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1-25")
	if (locale === "hi") return /** @type {LocalizedString} */ ("1-25")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("1-25")
	return /** @type {LocalizedString} */ ("1-25")
});